/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const PARTNERS = {
    BEP: {
        iconName: 'BEP',
        name: 'Bureau of Engraving and Printing (BEP)',
    },
    BLM: {
        iconName: 'BLM',
        name: 'Bureau of Land Management (BLM)',
    },
    BOR: { iconName: 'DOI', name: 'Bureau of Reclamation' },
    DOT: {
        iconName: 'DOT',
        name: 'U.S. Department of Transportation (USDOT)',
    },
    NPS: { iconName: 'NPS', name: 'National Park Service (NPS)' },
    NOAA: {
        iconName: 'NOAA',
        name: 'National Oceanic and Atmospheric Administration (NOAA)',
    },
    Presidio: { iconName: 'PT', name: 'Presidio Trust' },
    Smithsonian: { iconName: 'Smithsonian', name: 'Smithsonian' },
    TRE: { iconName: 'TRE', name: 'Department of The Treasury' },
    TVA: { iconName: 'TVA', name: 'Tennessee Valley Authority' },
    USACE: {
        iconName: 'USACE',
        name: 'U.S. Army Corps of Engineers (USACE)',
    },
    USFS: {
        iconName: 'ForestService',
        name: 'Forest Service (USFS)',
    },
    FS: {
        iconName: 'ForestService',
        name: 'Forest Service (USFS)',
    },
    USFWS: { iconName: 'FWS', name: 'U.S. Fish & Wildlife (USFWS)' },
    FWS: { iconName: 'FWS', name: 'U.S. Fish & Wildlife (USFWS)' },
} as const;

// cSpell:ignore NOAA, USACE, USDOT, USFS, USFWS
